import { combineReducers } from "redux"

// import counterReducer from "./counter"
import todoReducer from "./todo"
// import visibilityFilterReducer from "./visibilityFilter"

// For combining multiple reducers
const rootReducer = combineReducers({
  // counter: counterReducer,
  todos: todoReducer,
  // visibilityFilter: visibilityFilterReducer,
})

export default rootReducer
